module.exports = __webpack_public_path__ + "img/header-back-entry-shop.7957ee29.png";